import axios from "axios";

// Prefer same-origin in the browser so the app works correctly on any custom domain
// (e.g. deluxlimotransgroup.com OR dispatch-hub-372.emergent.host) without cross-origin
// preflights or credential restrictions in restrictive browsers (incognito, Safari ITP, etc).
// We still allow REACT_APP_BACKEND_URL as an override (used in some non-browser builds / SSR).
const BACKEND_URL =
  (typeof window !== "undefined" && window.location?.origin) ||
  process.env.REACT_APP_BACKEND_URL ||
  "";
export const API = `${BACKEND_URL}/api`;

// Authenticated axios (sends session cookie)
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Public axios (no credentials → works with wildcard CORS for unauthenticated endpoints)
export const publicApi = axios.create({
  baseURL: API,
  withCredentials: false,
});

// FastAPI 422 validation errors return `detail` as an ARRAY of objects
// ({type, loc, msg, ...}). Many call sites do toast.error(e.response.data.detail)
// — rendering a raw object crashes React ("Objects are not valid as a React
// child" → blank screen). Normalize detail to a readable string globally.
function normalizeDetail(error) {
  const d = error?.response?.data?.detail;
  if (d === undefined || typeof d === "string") return error;
  try {
    if (Array.isArray(d)) {
      error.response.data.detail = d
        .map((it) => {
          const field = Array.isArray(it?.loc) ? it.loc[it.loc.length - 1] : "";
          return [field, it?.msg].filter(Boolean).join(": ");
        })
        .filter(Boolean)
        .join(" · ") || "Validation error";
    } else {
      error.response.data.detail = JSON.stringify(d);
    }
  } catch {
    error.response.data.detail = "Request failed";
  }
  return error;
}
api.interceptors.response.use((r) => r, (e) => Promise.reject(normalizeDetail(e)));
publicApi.interceptors.response.use((r) => r, (e) => Promise.reject(normalizeDetail(e)));
